var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandardGameIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 43,
    viewBox: "0 0 51 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1481 1.43407L0 14.978L11.1481 19.1813L17.6512 3.3022L11.1481 1.43407Z",
    fill: "#B158E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6512 3.3022L11.1481 19.1813H39.0185L32.5154 3.3022H17.6512Z",
    fill: "#B158E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1481 19.1813L25.0833 43L39.0185 19.1813H11.1481Z",
    fill: "#B158E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.978L25.0833 43L11.1481 19.1813L0 14.978Z",
    fill: "#B158E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 43L50.1667 14.978L39.0185 19.1813L25.0833 43Z",
    fill: "#B158E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1667 14.978L39.0185 1.43407L32.5154 3.3022L39.0185 19.1813L50.1667 14.978Z",
    fill: "#B158E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1481 1.43407L17.6512 3.3022H32.5154L39.0185 1.43407L25.0833 0L11.1481 1.43407Z",
    fill: "#B158E7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.1481 1.43407L0 14.978L11.1481 19.1813L17.6512 3.3022L11.1481 1.43407Z",
    fill: "url(#paint0_linear_1792_25469)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6512 3.3022L11.1481 19.1813H39.0185L32.5154 3.3022H17.6512Z",
    fill: "url(#paint1_linear_1792_25469)",
    style: {
      mixBlendMode: "plus-lighter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1481 19.1813L25.0833 43L39.0185 19.1813H11.1481Z",
    fill: "url(#paint2_linear_1792_25469)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.978L25.0833 43L11.1481 19.1813L0 14.978Z",
    fill: "url(#paint3_linear_1792_25469)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 43L50.1667 14.978L39.0185 19.1813L25.0833 43Z",
    fill: "url(#paint4_linear_1792_25469)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1667 14.978L39.0185 1.43407L32.5154 3.3022L39.0185 19.1813L50.1667 14.978Z",
    fill: "url(#paint5_linear_1792_25469)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1481 1.43407L17.6512 3.3022H32.5154L39.0185 1.43407L25.0833 0L11.1481 1.43407Z",
    fill: "url(#paint6_linear_1792_25469)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1792_25469",
    x1: 17.5583,
    y1: 3.28824,
    x2: 10.9659,
    y2: 18.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1792_25469",
    x1: 25.0833,
    y1: 2.80435,
    x2: 25.0833,
    y2: 19.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1792_25469",
    x1: 25.0833,
    y1: 19.163,
    x2: 25.0833,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1792_25469",
    x1: 11.1481,
    y1: 19.163,
    x2: 25.2119,
    y2: 42.9239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1792_25469",
    x1: 39.4732,
    y1: 19.35,
    x2: 24.9816,
    y2: 42.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1792_25469",
    x1: 32.0509,
    y1: 2.33696,
    x2: 39.0924,
    y2: 19.1321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1792_25469",
    x1: 25.0833,
    y1: 0.5,
    x2: 25.0833,
    y2: 3.27174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardGameIcon);
export default __webpack_public_path__ + "static/media/standard-game-icon.685f2bd780e44802d3d82448c8f0714f.svg";
export { ForwardRef as ReactComponent };